const VALIDATE_TOKEN = {
  RESEND_TOKEN: 'Re-enviar código',
  CHANGE_PHONE_NUMBER: 'Alterar número',
  PREFIX_TIMER_TEXT: 'Aguarde ',
  SUFIX_TIMER_TEXT: ' para solicitar um novo re-envio de código.',
  CODE_HAS_BEEN_SENT: 'Código enviado!',
  ERROR_MESSAGE: {
    prefixText: 'Não foi possível re-enviar o código. ',
    sufixText: 'Por favor, tente novamente.'
  }
};

export default VALIDATE_TOKEN;
